'use es6';

const getOffset = (element, side) => {
  return parseInt(element[`margin${side}`], 10) + parseInt(element[`border${side}Width`], 10);
};
export const getDocumentBodyOffset = () => {
  const htmlStyle = window.getComputedStyle(document.documentElement);
  const bodyStyle = window.getComputedStyle(document.body);
  if (bodyStyle.position !== 'static') {
    return {
      left: getOffset(htmlStyle, 'Left') + getOffset(bodyStyle, 'Left'),
      top: getOffset(htmlStyle, 'Top') + getOffset(bodyStyle, 'Top')
    };
  } else if (htmlStyle.position !== 'static') {
    return {
      left: getOffset(htmlStyle, 'Left'),
      top: getOffset(htmlStyle, 'Top')
    };
  } else {
    return {
      left: 0,
      top: 0
    };
  }
};
export function calculateOffsetOnDragComponent({
  monitor,
  itemBeingDragged,
  dragPreviewHeightPx,
  dragPreviewWidthPx
}) {
  if (!monitor.isDragging()) {
    return null;
  }
  if (!itemBeingDragged) {
    return null;
  }
  const clientOffset = monitor.getClientOffset();
  const initialOffset = monitor.getSourceClientOffset();
  const offsetInsideItem = {
    x: initialOffset.x - clientOffset.x,
    y: initialOffset.y - clientOffset.y
  };
  const offsetFactors = {
    x: offsetInsideItem.x / itemBeingDragged.clientWidth,
    y: offsetInsideItem.y / itemBeingDragged.clientHeight
  };
  return {
    x: offsetFactors.x * dragPreviewHeightPx,
    y: offsetFactors.y * dragPreviewWidthPx
  };
}